import httpClient from '../httpClient';

const isFilled = value => typeof value === 'string' && value.trim() !== '';
const text = value => (typeof value === 'string' ? value.trim() : '');
const joinFilled = (parts, separator) => parts.map(text).filter(Boolean).join(separator);

export const isOutsideQrIntercomGeofence = error => {
    const message = error?.data?.message || error?.response?.data?.message || error?.message;
    return typeof message === 'string' &&
        message.toLowerCase().includes('visitor is outside the qr intercom geofence');
};

const normalizeContacts = contacts => (Array.isArray(contacts) ? contacts : [])
    .filter(contact => contact && typeof contact === 'object' && !Array.isArray(contact))
    .map(contact => ({
        name: text(contact.displayName),
        description: text(contact.description),
        phoneNumber: text(contact.phone),
        phoneTel: text(contact.phone).replace(/[\s()-]/g, ''),
    }))
    .filter(office => office.name || office.description || office.phoneNumber);

// e.g. "123 Main St, Apt 4, Austin, TX 78701" — only the parts the API returns
export function formatCommunityAddress(address) {
    if (!address || typeof address !== 'object') return '';
    const street = joinFilled([address.addressLine1, address.addressLine2], ', ');
    const region = joinFilled([address.state, address.postalCode], ' ');
    return joinFilled([street, address.city, region], ', ');
}

export function normalizeQrIntercom(data) {
    if (!data || typeof data !== 'object') throw new Error('Invalid QR intercom');
    if (typeof data.enabledForCommunity !== 'boolean' || typeof data.enabledForLocation !== 'boolean') {
        throw new Error('Invalid QR intercom');
    }
    const communityName = text(data.communityName);
    const name = text(data.name);
    if (!communityName && !name) throw new Error('Invalid QR intercom');
    return {
        communityName,
        name,
        description: text(data.description),
        address: formatCommunityAddress(data.communityAddress),
        offices: normalizeContacts(data.contacts),
        enabledForCommunity: data.enabledForCommunity,
        enabledForLocation: data.enabledForLocation,
    };
}

export async function getQrIntercom(publicId) {
    const baseURL = process.env.VUE_APP_QR_INTERCOM_API_URL?.trim();
    if (!baseURL) throw new Error('QR intercom API URL is missing');
    if (!isFilled(publicId)) throw new Error('QR intercom id is missing');
    const { data } = await httpClient(baseURL)({
        method: 'GET',
        url: `/access/qr-intercom/${encodeURIComponent(publicId)}`,
        timeout: 15000,
        headers: { Accept: 'application/json' },
    });
    return normalizeQrIntercom(data);
}

export async function verifyQrIntercomLocation(intercomId, coordinates) {
    const baseURL = process.env.VUE_APP_QR_INTERCOM_API_URL?.trim();
    if (!baseURL) throw new Error('QR intercom API URL is missing');
    if (!isFilled(intercomId)) throw new Error('QR intercom id is missing');
    if (!coordinates || ![coordinates.latitude, coordinates.longitude, coordinates.accuracy].every(Number.isFinite) ||
        Math.abs(coordinates.latitude) > 90 || Math.abs(coordinates.longitude) > 180 || coordinates.accuracy < 0) {
        throw new Error('Visitor location is invalid');
    }
    const { data } = await httpClient(baseURL)({
        method: 'POST',
        url: `/access/qr-intercom/${encodeURIComponent(intercomId)}/geofence-verifications`,
        timeout: 15000,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        data: {
            latitude: coordinates.latitude,
            longitude: coordinates.longitude,
            accuracyMeters: coordinates.accuracy,
        },
    });
    return data;
}
